import { Chip, ChipProps } from '@material-ui/core';
import React from 'react';
// import styles from './SGSChip.module.scss';

type Props = ChipProps;

const SGSChip: React.FC<Props> = ({ ...props }) => {
    return <Chip {...props} />;
};

export default SGSChip;
